// import React, { useState, useEffect } from 'react';
// import { database, ref, get } from '../../firebase';
// import { 
//   History, ArrowRightLeft, Calendar, DollarSign, CheckCircle2, 
//   XCircle, RefreshCw, Download, ChevronDown, ChevronUp,
//   Wallet, User
// } from 'lucide-react';

// const TransferHistory = () => {
//   const [transfers, setTransfers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [totalStats, setTotalStats] = useState({
//     count: 0,
//     totalAmount: 0,
//   });
//   const [expandedTransfer, setExpandedTransfer] = useState(null);
//   const [filter, setFilter] = useState('all');

//   const userId = localStorage.getItem('userId') || '';
//   const userName = localStorage.getItem('userName') || '';
//   const userDbKey = localStorage.getItem('dbKey') || '';

//   useEffect(() => {
//     if (!userId) {
//       setError("User ID not found. Please login again.");
//       setLoading(false);
//       return;
//     }

//     fetchTransferHistory();
//   }, [userId]);

//   const fetchTransferHistory = async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       const transfersRef = ref(database, 'Transfers');
//       const snapshot = await get(transfersRef);

//       let allTransfers = [];

//       if (snapshot.exists()) {
//         const data = snapshot.val();
        
//         // Loop through date folders (like 2026-02-06)
//         Object.keys(data).forEach(dateFolder => {
//           const dateData = data[dateFolder];
//           if (typeof dateData === 'object') {
//             Object.keys(dateData).forEach(userIdFolder => {
//               const userTransfers = dateData[userIdFolder];
//               if (typeof userTransfers === 'object') {
//                 Object.keys(userTransfers).forEach(transferKey => {
//                   const transfer = userTransfers[transferKey];
                  
//                   // Check if this transfer belongs to current user
//                   if (transfer.userId === userId || transfer.userDbKey === userDbKey) {
//                     allTransfers.push({
//                       id: transfer.id || transferKey,
//                       date: transfer.date || new Date().toISOString(),
//                       timestamp: transfer.timestamp || Date.now(),
//                       fromWallet: transfer.fromWallet || '',
//                       toWallet: transfer.toWallet || '',
//                       amount: Number(transfer.amount || 0),
//                       status: transfer.status || 'completed',
//                       userId: transfer.userId || '',
//                       userName: transfer.userName || '',
//                       userEmail: transfer.userEmail || '',
//                       previousFromBalance: Number(transfer.previousFromBalance || 0),
//                       previousToBalance: Number(transfer.previousToBalance || 0),
//                       newFromBalance: Number(transfer.newFromBalance || 0),
//                       newToBalance: Number(transfer.newToBalance || 0),
//                       dateFolder: dateFolder,
//                       firebaseId: transferKey
//                     });
//                   }
//                 });
//               }
//             });
//           }
//         });
//       }

//       // Sort by timestamp (newest first)
//       allTransfers.sort((a, b) => b.timestamp - a.timestamp);
      
//       setTransfers(allTransfers);

//       const totalAmount = allTransfers.reduce((sum, t) => sum + (t.amount || 0), 0);
//       setTotalStats({
//         count: allTransfers.length,
//         totalAmount: totalAmount,
//       });

//     } catch (err) {
//       console.error("Transfer history fetch error:", err);
//       setError("Could not load transfer history. Please check your internet connection.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return '—';
//     try {
//       const date = new Date(dateString);
//       return date.toLocaleString('en-US', {
//         month: 'short',
//         day: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit',
//       });
//     } catch {
//       return dateString;
//     }
//   };

//   const getWalletLabel = (wallet) => {
//     const map = {
//       working: "AV Power Wallet",
//       roi: "AV ROI Wallet",
//       aurum: "Aerovolt Wallet",
//       energy: "AV Energy Wallet"
//     };
//     return map[wallet] || wallet;
//   };

//   const getStatusColor = (status) => {
//     const map = {
//       completed: 'bg-green-900/50 text-green-400 border-green-700/40',
//       pending: 'bg-yellow-900/50 text-yellow-400 border-yellow-700/40',
//       failed: 'bg-red-900/50 text-red-400 border-red-700/40'
//     };
//     return map[status] || 'bg-gray-900/50 text-gray-400 border-gray-700/40';
//   };

//   const toggleTransfer = (id) => {
//     setExpandedTransfer(expandedTransfer === id ? null : id);
//   };

//   const filteredTransfers = transfers.filter(transfer => {
//     if (filter === 'all') return true;
//     return transfer.status === filter;
//   });

//   const downloadCSV = () => {
//     const headers = ['Date', 'From Wallet', 'To Wallet', 'Amount', 'Status'];
//     const csvData = transfers.map(t => {
//       return [
//         formatDate(t.date),
//         getWalletLabel(t.fromWallet),
//         getWalletLabel(t.toWallet),
//         `$${t.amount.toFixed(2)}`,
//         t.status
//       ];
//     });
    
//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.join(','))
//     ].join('\n');
    
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `transfer-history-${userId}-${Date.now()}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     URL.revokeObjectURL(url);
//   };

//   if (loading) {
//     return (
//       <div className="flex flex-col items-center justify-center min-h-[60vh]">
//         <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-primary border-solid mb-4"></div>
//         <p className="text-primary">Fetching transfer history...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="max-w-3xl mx-auto pt-20 px-4 text-center">
//         <XCircle className="h-16 w-16 text-destructive mx-auto mb-6" />
//         <h2 className="text-2xl font-bold text-destructive mb-4">Connection Error</h2>
//         <p className="text-muted-foreground mb-6">{error}</p>
//         <button
//           onClick={fetchTransferHistory}
//           className="btn-electric inline-flex items-center gap-2 px-8 py-3 rounded-lg font-medium transition"
//         >
//           <RefreshCw size={18} />
//           Try Again
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-6xl mx-auto pt-16 md:pt-20 px-4 pb-12">
//       {/* Header */}
//       <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
//         <div>
//           <h1 className="text-3xl md:text-4xl font-bold text-foreground">Transfer History</h1>
//           <p className="text-muted-foreground mt-2">
//             {userName} • ID: {userId}
//           </p>
//         </div>
        
//         <div className="flex items-center gap-3">
//           <div className="flex items-center gap-4 bg-card border border-border rounded-xl px-4 py-3">
//             <div className="text-center">
//               <div className="text-xs text-muted-foreground">Total Transfers</div>
//               <div className="text-lg font-bold text-foreground">{totalStats.count}</div>
//             </div>
//             <div className="h-8 w-px bg-border"></div>
//             <div className="text-center">
//               <div className="text-xs text-muted-foreground">Total Amount</div>
//               <div className="text-lg font-bold text-green-400">${totalStats.totalAmount.toFixed(2)}</div>
//             </div>
//           </div>
          
//           {transfers.length > 0 && (
//             <button
//               onClick={downloadCSV}
//               className="flex items-center gap-2 px-4 py-3 bg-green-900/40 hover:bg-green-800/60 border border-green-700/50 rounded-lg text-green-200 text-sm transition"
//             >
//               <Download size={16} />
//               Export
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Filter Tabs */}
//       <div className="flex overflow-x-auto gap-2 mb-6 pb-2">
//         {['all', 'completed', 'pending', 'failed'].map((status) => (
//           <button
//             key={status}
//             onClick={() => setFilter(status)}
//             className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap ${
//               filter === status
//                 ? status === 'completed' ? 'bg-green-900/40 text-green-400 border border-green-700/40' :
//                   status === 'pending' ? 'bg-yellow-900/40 text-yellow-400 border border-yellow-700/40' :
//                   status === 'failed' ? 'bg-red-900/40 text-red-400 border border-red-700/40' :
//                   'bg-primary/40 text-primary border border-primary/40'
//                 : 'bg-secondary text-muted-foreground'
//             }`}
//           >
//             {status === 'all' ? 'All' : status.charAt(0).toUpperCase() + status.slice(1)}
//             {status !== 'all' && (
//               <span className="ml-2 text-xs opacity-75">
//                 ({transfers.filter(t => t.status === status).length})
//               </span>
//             )}
//           </button>
//         ))}
//       </div>

//       {/* Main Content */}
//       {transfers.length === 0 ? (
//         <div className="card-glow bg-gradient-to-br from-background to-primary/5 border border-border rounded-2xl p-10 text-center">
//           <div className="relative mx-auto w-32 h-32 mb-6">
//             <div className="absolute inset-0 bg-primary/10 rounded-full animate-pulse"></div>
//             <History className="h-32 w-32 text-primary opacity-50" />
//           </div>
//           <h3 className="text-2xl font-bold text-foreground mb-3">No Transfers Found</h3>
//           <p className="text-muted-foreground max-w-md mx-auto mb-8">
//             You haven't made any wallet transfers yet.
//           </p>
//           <button
//             onClick={() => window.location.href = '/user-dashboard/transfer'}
//             className="btn-electric px-8 py-3 rounded-xl transition"
//           >
//             Make Your First Transfer
//           </button>
//         </div>
//       ) : (
//         <div className="space-y-3">
//           {filteredTransfers.map((t, index) => (
//             <div key={t.id} className="card-glow bg-card border border-border rounded-xl overflow-hidden">
//               {/* Accordion Header */}
//               <button
//                 onClick={() => toggleTransfer(t.id)}
//                 className="w-full p-4 flex items-center justify-between hover:bg-secondary/10 transition-colors"
//               >
//                 <div className="flex items-center gap-3 flex-1">
//                   <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center">
//                     <ArrowRightLeft className="h-5 w-5 text-primary" />
//                   </div>
                  
//                   <div className="text-left flex-1">
//                     <div className="flex items-center gap-2 mb-1">
//                       <span className="text-sm font-medium text-foreground">
//                         {getWalletLabel(t.fromWallet)} → {getWalletLabel(t.toWallet)}
//                       </span>
//                       <span className={`text-xs px-2 py-0.5 rounded-full ${getStatusColor(t.status)}`}>
//                         {t.status}
//                       </span>
//                     </div>
//                     <div className="text-xs text-muted-foreground flex items-center gap-2">
//                       <Calendar size={12} />
//                       {formatDate(t.date)}
//                     </div>
//                   </div>
//                 </div>
                
//                 <div className="flex flex-col items-end ml-2">
//                   <div className="text-lg font-bold text-green-400">
//                     ${t.amount.toFixed(2)}
//                   </div>
//                   <div className="text-xs text-muted-foreground mt-1">
//                     #{index + 1}
//                   </div>
//                 </div>
                
//                 <div className="ml-4">
//                   {expandedTransfer === t.id ? (
//                     <ChevronUp className="h-5 w-5 text-muted-foreground" />
//                   ) : (
//                     <ChevronDown className="h-5 w-5 text-muted-foreground" />
//                   )}
//                 </div>
//               </button>
              
//               {/* Accordion Content */}
//               {expandedTransfer === t.id && (
//                 <div className="border-t border-border p-4">
//                   <div className="space-y-4">
//                     {/* Transfer Details */}
//                     <div className="grid grid-cols-2 gap-3">
//                       <div className="bg-secondary/40 p-3 rounded-lg">
//                         <div className="text-xs text-muted-foreground mb-1">From Wallet</div>
//                         <div className="font-medium text-foreground">{getWalletLabel(t.fromWallet)}</div>
//                         <div className="text-sm text-green-400 mt-1">
//                           ${t.amount.toFixed(2)} transferred
//                         </div>
//                       </div>
                      
//                       <div className="bg-secondary/40 p-3 rounded-lg">
//                         <div className="text-xs text-muted-foreground mb-1">To Wallet</div>
//                         <div className="font-medium text-foreground">{getWalletLabel(t.toWallet)}</div>
//                         <div className="text-sm text-primary mt-1">
//                           Received ${t.amount.toFixed(2)}
//                         </div>
//                       </div>
//                     </div>
                    
//                     {/* Balance Changes */}
//                     <div className="bg-gradient-to-r from-primary/10 to-primary/5 p-3 rounded-lg">
//                       <div className="text-sm font-medium text-primary mb-2">Balance Changes</div>
//                       <div className="grid grid-cols-2 gap-3">
//                         <div>
//                           <div className="text-xs text-muted-foreground mb-1">From Balance</div>
//                           <div className="flex items-center gap-2">
//                             <span className="text-sm line-through text-muted-foreground">
//                               ${t.previousFromBalance?.toFixed(2)}
//                             </span>
//                             <ArrowRightLeft size={12} className="text-muted-foreground" />
//                             <span className="text-sm font-bold text-green-400">
//                               ${t.newFromBalance?.toFixed(2)}
//                             </span>
//                           </div>
//                         </div>
                        
//                         <div>
//                           <div className="text-xs text-muted-foreground mb-1">To Balance</div>
//                           <div className="flex items-center gap-2">
//                             <span className="text-sm line-through text-muted-foreground">
//                               ${t.previousToBalance?.toFixed(2)}
//                             </span>
//                             <ArrowRightLeft size={12} className="text-muted-foreground" />
//                             <span className="text-sm font-bold text-primary">
//                               ${t.newToBalance?.toFixed(2)}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
                    
//                     {/* Transaction Info */}
//                     <div className="space-y-3">
//                       <div className="flex items-center gap-2 text-sm">
//                         <Wallet size={14} className="text-primary" />
//                         <div className="flex-1">
//                           <div className="text-muted-foreground text-xs">Transaction ID</div>
//                           <div className="font-mono text-primary text-sm truncate">{t.id}</div>
//                         </div>
//                       </div>
                      
//                       <div className="flex items-center gap-2 text-sm">
//                         <User size={14} className="text-primary" />
//                         <div className="flex-1">
//                           <div className="text-muted-foreground text-xs">User</div>
//                           <div className="text-foreground truncate">{t.userName || 'N/A'}</div>
//                           <div className="text-xs text-muted-foreground truncate">{t.userEmail}</div>
//                         </div>
//                       </div>
                      
//                       <div className="flex items-center gap-2 text-sm">
//                         <Calendar size={14} className="text-primary" />
//                         <div className="flex-1">
//                           <div className="text-muted-foreground text-xs">Date & Time</div>
//                           <div className="text-foreground text-sm">{formatDate(t.date)}</div>
//                         </div>
//                       </div>
//                     </div>
                    
//                     {/* Status */}
//                     <div className="flex items-center justify-between pt-3 border-t border-border">
//                       <div className="text-sm text-muted-foreground">
//                         Transfer #{index + 1} of {filteredTransfers.length}
//                       </div>
//                       <span className={`px-3 py-1.5 rounded-full text-xs font-medium flex items-center gap-1.5 ${getStatusColor(t.status)}`}>
//                         {t.status === 'completed' ? (
//                           <><CheckCircle2 size={12} /> Completed</>
//                         ) : t.status === 'pending' ? (
//                           <><RefreshCw size={12} /> Pending</>
//                         ) : (
//                           <><XCircle size={12} /> Failed</>
//                         )}
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Footer */}
//       {transfers.length > 0 && (
//         <div className="card-glow bg-card border border-border rounded-2xl p-4 mt-6">
//           <div className="flex flex-col sm:flex-row justify-between items-center">
//             <div className="text-muted-foreground text-sm text-center sm:text-left mb-3 sm:mb-0">
//               Showing <span className="text-foreground font-bold">{filteredTransfers.length}</span> of <span className="text-foreground">{transfers.length}</span> transfers
//             </div>
//             <div className="flex items-center gap-4">
//               <button
//                 onClick={downloadCSV}
//                 className="text-green-400 hover:text-green-300 text-sm flex items-center gap-1"
//               >
//                 <Download size={14} />
//                 Export CSV
//               </button>
//               <button
//                 onClick={fetchTransferHistory}
//                 className="text-muted-foreground hover:text-foreground text-sm flex items-center gap-1"
//               >
//                 <RefreshCw size={14} />
//                 Refresh
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TransferHistory;



import React, { useState, useEffect } from 'react';
import { database, ref, get } from '../../firebase';
import { 
  History, ArrowRightLeft, Calendar, DollarSign, CheckCircle2, 
  XCircle, RefreshCw, Download, ChevronDown, ChevronUp,
  Wallet, User
} from 'lucide-react';

const TransferHistory = () => {
  const [transfers, setTransfers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalStats, setTotalStats] = useState({
    count: 0,
    totalAmount: 0,
  });
  const [expandedTransfer, setExpandedTransfer] = useState(null);
  const [filter, setFilter] = useState('all');

  const userId = localStorage.getItem('userId') || '';
  const userName = localStorage.getItem('userName') || '';
  const userDbKey = localStorage.getItem('dbKey') || '';

  useEffect(() => {
    if (!userId) {
      setError("User ID not found. Please login again.");
      setLoading(false);
      return;
    }

    fetchTransferHistory();
  }, [userId]);

  const fetchTransferHistory = async () => {
    setLoading(true);
    setError(null);

    try {
      const transfersRef = ref(database, 'Transfers');
      const snapshot = await get(transfersRef);

      let allTransfers = [];

      if (snapshot.exists()) {
        const data = snapshot.val();
        
        // Loop through date folders (like 2026-02-06)
        Object.keys(data).forEach(dateFolder => {
          const dateData = data[dateFolder];
          if (typeof dateData === 'object') {
            Object.keys(dateData).forEach(userIdFolder => {
              const userTransfers = dateData[userIdFolder];
              if (typeof userTransfers === 'object') {
                Object.keys(userTransfers).forEach(transferKey => {
                  const transfer = userTransfers[transferKey];
                  
                  // Check if this transfer belongs to current user
                  if (transfer.userId === userId || transfer.userDbKey === userDbKey) {
                    allTransfers.push({
                      id: transfer.id || transferKey,
                      date: transfer.date || new Date().toISOString(),
                      timestamp: transfer.timestamp || Date.now(),
                      fromWallet: transfer.fromWallet || '',
                      toWallet: transfer.toWallet || '',
                      amount: Number(transfer.amount || 0),
                      status: transfer.status || 'completed',
                      userId: transfer.userId || '',
                      userName: transfer.userName || '',
                      userEmail: transfer.userEmail || '',
                      previousFromBalance: Number(transfer.previousFromBalance || 0),
                      previousToBalance: Number(transfer.previousToBalance || 0),
                      newFromBalance: Number(transfer.newFromBalance || 0),
                      newToBalance: Number(transfer.newToBalance || 0),
                      dateFolder: dateFolder,
                      firebaseId: transferKey
                    });
                  }
                });
              }
            });
          }
        });
      }

      // Sort by timestamp (newest first)
      allTransfers.sort((a, b) => b.timestamp - a.timestamp);
      
      setTransfers(allTransfers);

      const totalAmount = allTransfers.reduce((sum, t) => sum + (t.amount || 0), 0);
      setTotalStats({
        count: allTransfers.length,
        totalAmount: totalAmount,
      });

    } catch (err) {
      console.error("Transfer history fetch error:", err);
      setError("Could not load transfer history. Please check your internet connection.");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '—';
    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return dateString;
    }
  };

  const getWalletLabel = (wallet) => {
    const map = {
      working: "AV Power Wallet",
      roi: "AV ROI Wallet",
      aurum: "Aerovolt Wallet",
      energy: "AV Energy Wallet"
    };
    return map[wallet] || wallet;
  };

  const getStatusColor = (status) => {
    const map = {
      completed: 'bg-green-500/10 text-green-400 border-green-500/30',
      pending: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/30',
      failed: 'bg-red-500/10 text-red-400 border-red-500/30'
    };
    return map[status] || 'bg-secondary text-muted-foreground border-border';
  };

  const toggleTransfer = (id) => {
    setExpandedTransfer(expandedTransfer === id ? null : id);
  };

  const filteredTransfers = transfers.filter(transfer => {
    if (filter === 'all') return true;
    return transfer.status === filter;
  });

  const downloadCSV = () => {
    const headers = ['Date', 'From Wallet', 'To Wallet', 'Amount', 'Status'];
    const csvData = transfers.map(t => {
      return [
        formatDate(t.date),
        getWalletLabel(t.fromWallet),
        getWalletLabel(t.toWallet),
        `$${t.amount.toFixed(2)}`,
        t.status
      ];
    });
    
    const csvContent = [
      headers.join(','),
      ...csvData.map(row => row.join(','))
    ].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `transfer-history-${userId}-${Date.now()}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-background">
        <div className="px-3 pt-12 pb-4">
          <div className="flex flex-col items-center justify-center h-48">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mb-3"></div>
            <p className="text-xs text-primary">Fetching transfer history...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-background">
        <div className="px-3 pt-12 pb-4 text-center">
          <XCircle className="h-12 w-12 text-destructive mx-auto mb-4" />
          <h2 className="text-base font-bold text-destructive mb-2">Connection Error</h2>
          <p className="text-xs text-muted-foreground mb-4">{error}</p>
          <button
            onClick={fetchTransferHistory}
            className="btn-electric inline-flex items-center gap-1 px-4 py-2 rounded-lg text-xs font-medium transition"
          >
            <RefreshCw size={12} />
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="px-3 pt-10 pb-4">
        {/* Header */}
        <div className="flex flex-col gap-3 mb-4">
          <div>
            <h1 className="text-base font-semibold text-foreground">Transfer History</h1>
            <p className="text-xs text-muted-foreground mt-0.5">
              {userName} • ID: {userId}
            </p>
          </div>
          
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 bg-card border border-border rounded-lg px-3 py-2">
              <div className="text-center">
                <div className="text-[9px] text-muted-foreground">Total</div>
                <div className="text-xs font-bold text-foreground">{totalStats.count}</div>
              </div>
              <div className="h-6 w-px bg-border"></div>
              <div className="text-center">
                <div className="text-[9px] text-muted-foreground">Amount</div>
                <div className="text-xs font-bold text-green-400">${totalStats.totalAmount.toFixed(2)}</div>
              </div>
            </div>
            
            {transfers.length > 0 && (
              <button
                onClick={downloadCSV}
                className="flex items-center gap-1.5 px-3 py-2 bg-green-500/10 hover:bg-green-500/20 border border-green-500/30 rounded-lg text-green-400 text-xs transition"
              >
                <Download size={12} />
                Export
              </button>
            )}
          </div>
        </div>

        {/* Filter Tabs */}
        <div className="flex overflow-x-auto gap-1 mb-4 pb-1">
          {['all', 'completed', 'pending', 'failed'].map((status) => (
            <button
              key={status}
              onClick={() => setFilter(status)}
              className={`px-3 py-1.5 rounded-lg text-[10px] font-medium whitespace-nowrap ${
                filter === status
                  ? status === 'completed' ? 'bg-green-500/20 text-green-400 border border-green-500/30' :
                    status === 'pending' ? 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/30' :
                    status === 'failed' ? 'bg-red-500/20 text-red-400 border border-red-500/30' :
                    'bg-primary/20 text-primary border border-primary/30'
                  : 'bg-secondary text-muted-foreground'
              }`}
            >
              {status === 'all' ? 'All' : status.charAt(0).toUpperCase() + status.slice(1)}
              {status !== 'all' && (
                <span className="ml-1 text-[8px] opacity-75">
                  ({transfers.filter(t => t.status === status).length})
                </span>
              )}
            </button>
          ))}
        </div>

        {/* Main Content */}
        {transfers.length === 0 ? (
          <div className="bg-card border border-border rounded-xl p-6 text-center">
            <div className="relative mx-auto w-16 h-16 mb-3">
              <div className="absolute inset-0 bg-primary/10 rounded-full animate-pulse"></div>
              <History className="h-16 w-16 text-primary opacity-50" />
            </div>
            <h3 className="text-sm font-bold text-foreground mb-1">No Transfers Found</h3>
            <p className="text-[10px] text-muted-foreground max-w-md mx-auto mb-4">
              You haven't made any wallet transfers yet.
            </p>
            <button
              onClick={() => window.location.href = '/user-dashboard/transfer'}
              className="btn-electric px-4 py-2 rounded-lg text-xs transition"
            >
              Make Your First Transfer
            </button>
          </div>
        ) : (
          <div className="space-y-2">
            {filteredTransfers.map((t, index) => (
              <div key={t.id} className="bg-card border border-border rounded-lg overflow-hidden">
                {/* Accordion Header */}
                <button
                  onClick={() => toggleTransfer(t.id)}
                  className="w-full p-3 flex items-center justify-between hover:bg-secondary/10 transition-colors"
                >
                  <div className="flex items-center gap-2 flex-1">
                    <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center">
                      <ArrowRightLeft className="h-4 w-4 text-primary" />
                    </div>
                    
                    <div className="text-left flex-1">
                      <div className="flex items-center gap-1.5 mb-0.5">
                        <span className="text-[10px] font-medium text-foreground truncate max-w-[120px]">
                          {getWalletLabel(t.fromWallet)}
                        </span>
                        <span className="text-[8px] text-muted-foreground">→</span>
                        <span className="text-[10px] font-medium text-foreground truncate max-w-[120px]">
                          {getWalletLabel(t.toWallet)}
                        </span>
                      </div>
                      <div className="text-[8px] text-muted-foreground flex items-center gap-1">
                        <Calendar size={8} />
                        {formatDate(t.date)}
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-2">
                    <div className="text-right">
                      <div className="text-xs font-bold text-green-400">
                        ${t.amount.toFixed(2)}
                      </div>
                      <span className={`text-[6px] px-1 py-0.5 rounded-full ${getStatusColor(t.status)}`}>
                        {t.status}
                      </span>
                    </div>
                    
                    <div>
                      {expandedTransfer === t.id ? (
                        <ChevronUp className="h-3.5 w-3.5 text-muted-foreground" />
                      ) : (
                        <ChevronDown className="h-3.5 w-3.5 text-muted-foreground" />
                      )}
                    </div>
                  </div>
                </button>
                
                {/* Accordion Content */}
                {expandedTransfer === t.id && (
                  <div className="border-t border-border p-3">
                    <div className="space-y-3">
                      {/* Transfer Details */}
                      <div className="grid grid-cols-2 gap-2">
                        <div className="bg-secondary/40 p-2 rounded-lg">
                          <div className="text-[8px] text-muted-foreground mb-0.5">From Wallet</div>
                          <div className="text-[10px] font-medium text-foreground">{getWalletLabel(t.fromWallet)}</div>
                          <div className="text-[8px] text-green-400 mt-1">
                            -${t.amount.toFixed(2)}
                          </div>
                        </div>
                        
                        <div className="bg-secondary/40 p-2 rounded-lg">
                          <div className="text-[8px] text-muted-foreground mb-0.5">To Wallet</div>
                          <div className="text-[10px] font-medium text-foreground">{getWalletLabel(t.toWallet)}</div>
                          <div className="text-[8px] text-primary mt-1">
                            +${t.amount.toFixed(2)}
                          </div>
                        </div>
                      </div>
                      
                      {/* Balance Changes */}
                      <div className="bg-primary/5 p-2 rounded-lg">
                        <div className="text-[9px] font-medium text-primary mb-1.5">Balance Changes</div>
                        <div className="space-y-2">
                          <div>
                            <div className="text-[7px] text-muted-foreground mb-0.5">From Balance</div>
                            <div className="flex items-center gap-1">
                              <span className="text-[8px] line-through text-muted-foreground">
                                ${t.previousFromBalance?.toFixed(2)}
                              </span>
                              <ArrowRightLeft size={8} className="text-muted-foreground" />
                              <span className="text-[9px] font-bold text-green-400">
                                ${t.newFromBalance?.toFixed(2)}
                              </span>
                            </div>
                          </div>
                          
                          <div>
                            <div className="text-[7px] text-muted-foreground mb-0.5">To Balance</div>
                            <div className="flex items-center gap-1">
                              <span className="text-[8px] line-through text-muted-foreground">
                                ${t.previousToBalance?.toFixed(2)}
                              </span>
                              <ArrowRightLeft size={8} className="text-muted-foreground" />
                              <span className="text-[9px] font-bold text-primary">
                                ${t.newToBalance?.toFixed(2)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      {/* Transaction Info */}
                      <div className="space-y-2">
                        <div className="flex items-center gap-1.5">
                          <Wallet size={10} className="text-primary" />
                          <div className="flex-1">
                            <div className="text-[7px] text-muted-foreground">Transaction ID</div>
                            <div className="font-mono text-[8px] text-primary truncate">{t.id}</div>
                          </div>
                        </div>
                        
                        <div className="flex items-center gap-1.5">
                          <User size={10} className="text-primary" />
                          <div className="flex-1">
                            <div className="text-[7px] text-muted-foreground">User</div>
                            <div className="text-[8px] text-foreground truncate">{t.userName || 'N/A'}</div>
                            <div className="text-[7px] text-muted-foreground truncate">{t.userEmail}</div>
                          </div>
                        </div>
                        
                        <div className="flex items-center gap-1.5">
                          <Calendar size={10} className="text-primary" />
                          <div className="flex-1">
                            <div className="text-[7px] text-muted-foreground">Date & Time</div>
                            <div className="text-[8px] text-foreground">{formatDate(t.date)}</div>
                          </div>
                        </div>
                      </div>
                      
                      {/* Status */}
                      <div className="flex items-center justify-between pt-2 border-t border-border">
                        <div className="text-[7px] text-muted-foreground">
                          Transfer #{index + 1} of {filteredTransfers.length}
                        </div>
                        <span className={`px-2 py-0.5 rounded-full text-[7px] font-medium flex items-center gap-1 ${getStatusColor(t.status)}`}>
                          {t.status === 'completed' ? (
                            <><CheckCircle2 size={8} /> Completed</>
                          ) : t.status === 'pending' ? (
                            <><RefreshCw size={8} /> Pending</>
                          ) : (
                            <><XCircle size={8} /> Failed</>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Footer */}
        {transfers.length > 0 && (
          <div className="bg-card border border-border rounded-lg p-3 mt-4">
            <div className="flex flex-col gap-2">
              <div className="text-[8px] text-muted-foreground text-center">
                Showing <span className="text-foreground font-bold">{filteredTransfers.length}</span> of <span className="text-foreground">{transfers.length}</span> transfers
              </div>
              <div className="flex items-center justify-center gap-3">
                <button
                  onClick={downloadCSV}
                  className="text-[9px] text-green-400 hover:text-green-300 flex items-center gap-1"
                >
                  <Download size={8} />
                  Export CSV
                </button>
                <button
                  onClick={fetchTransferHistory}
                  className="text-[9px] text-muted-foreground hover:text-foreground flex items-center gap-1"
                >
                  <RefreshCw size={8} />
                  Refresh
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TransferHistory;